import { defineAsyncComponent } from 'vue'
export default {
  articles: defineAsyncComponent(() => import("/home/yyi/ws-projekte/ws-website-2.0/layouts/articles.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/yyi/ws-projekte/ws-website-2.0/layouts/default.vue").then(m => m.default || m))
}